import { Injectable } from '@angular/core';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})

export class AccessibilityService extends ServiceBase {

  public updatePrimeNGPaginatorButtons(nativeElement: HTMLElement): void {
    try {
      window.setTimeout(() => {
        let paginatorButtons = (<HTMLElement>nativeElement).querySelectorAll(".p-paginator button.p-paginator-element");
        for (let i = 0; i < paginatorButtons.length; i++) {
          let buttonEl: HTMLButtonElement = <HTMLButtonElement>paginatorButtons.item(i);
          let buttonType = buttonEl.classList;
          let ariaLabelText: string = null;

          if (buttonType.contains('p-paginator-first')) {
            ariaLabelText = 'Navigate to first page of the datagrid.';
          } else if (buttonType.contains('p-paginator-prev')) {
            ariaLabelText = 'Navigate to previous page in the datagrid';
          } else if (buttonType.contains('p-paginator-page')) {
            let pageNumber: string = buttonEl.textContent;
            ariaLabelText = `Navigate to page ${pageNumber} of the datagrid`;
          } else if (buttonType.contains('p-paginator-next')) {
            ariaLabelText = 'Navigate to next page in the datagrid';
          } else if (buttonType.contains('p-paginator-last')) {
            ariaLabelText = 'Navigate to last page in the datagrid';
          }

          buttonEl.setAttribute("aria-label", ariaLabelText);
        }
      }, 2000);
    } catch (e) {
      console.log(e);
    }

  }

  public updatePrimeNGFileUploadInput(nativeElement: HTMLElement, inputId?: string): void {
    try {
      window.setTimeout(() => {
        let fileUploadInput = (<HTMLElement>nativeElement)?.querySelector(".p-fileupload .p-fileupload-choose input[type=file]");
        if (!!fileUploadInput) {
          fileUploadInput.setAttribute('id', inputId ?? 'fileUploadInput');
        }
      }, 2000);
    } catch (e) {
      console.log(e);
    }
  }
}
